/**
 * @fileoverview DELETE handler for the "/apps/user_info/delete_users_from_segment" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsUserInfoDeleteUsersFromSegmentCacheKeys } from "./constants";
import type {
  DeleteAppsUserInfoDeleteUsersFromSegmentProps,
  AppsUserInfoDeleteUsersFromSegmentResult,
} from "./types";

export const deleteAppsUserInfoDeleteUsersFromSegment = reactQueryMutationAdapter(
  appsUserInfoDeleteUsersFromSegmentCacheKeys,
  (props: DeleteAppsUserInfoDeleteUsersFromSegmentProps): Promise<AppsUserInfoDeleteUsersFromSegmentResult> => {
    return fetch("/apps/user_info/delete_users_from_segment", "DELETE", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
